/** The recap is read in one room by one crowd; the locale is the party's, not the browser's. */
const LOCALE = 'en-GB';

const MS_PER_MINUTE = 60_000;
const MINUTES_PER_HOUR = 60;

export const formatInt = (n: number): string => Math.round(n).toLocaleString(LOCALE);

export const formatHm = (ms: number): string => {
  const minutes = Math.round(ms / MS_PER_MINUTE);
  const hours = Math.floor(minutes / MINUTES_PER_HOUR);

  return hours > 0
    ? `${String(hours)}h ${String(minutes % MINUTES_PER_HOUR).padStart(2, '0')}m`
    : `${String(minutes)}m`;
};

export const formatMinutes = (ms: number): string =>
  Math.round(ms / MS_PER_MINUTE).toLocaleString(LOCALE);

export const formatPercent = (fraction: number): string => `${String(Math.round(fraction * 100))}%`;

export const formatClock = (date: Date): string =>
  date.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' });

export const formatDay = (date: Date): string =>
  date.toLocaleDateString(LOCALE, { weekday: 'long', day: 'numeric', month: 'long' });

const TIMES_WORDS: Readonly<Record<number, string>> = { 0: 'never', 1: 'once', 2: 'twice' };

export const formatTimes = (n: number): string => TIMES_WORDS[n] ?? `${String(n)} times`;
